import { graphql } from '@/client/services/api/graphql/gql';

export const manuallySyncExpertMutation = graphql(`
  mutation ManuallySyncExpert($expertId: String!) {
    manuallySyncExpert(expertId: $expertId) 
  }
`);